// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicePriorities_ClonarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /so/service_priorities/clonar
 *
 * Wire shape preserved from legacy: `dados: { cloned: int }` — count of
 * service-priority rows successfully cloned to the target franchise.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ServicePriorities_ClonarResponseDados {
cloned: number
}

export type ServicePriorities_ClonarResponse = ApiResponse<ServicePriorities_ClonarResponseDados>;

registerResponseContract('ServicePriorities_ClonarResponse', {
  cloned: { type: 'number',  required: true },
})
